import moment from "moment"

const monthTickFormat = datum => moment(datum).format("MMM YYYY")
const dayTickFormat = datum => moment(datum).format("MMM DD")
const customMonthTickFormat = datum => moment(datum).format("MMM 'YY")

export const xAxisTicks = (min, max) => {
  const diff = moment(max).diff(moment(min), "days")

  if (diff <= 1) {
    return [1, dayTickFormat]
  } else if (diff <= 100) {
    return [5, dayTickFormat]
  } else if (diff <= 180) {
    return [5, monthTickFormat]
  }

  return [null, monthTickFormat]
}

export const xSmallAxisTicks = (min, max) => {
  const diff = moment(max).diff(moment(min), "days")

  if (diff <= 1) {
    return [1, dayTickFormat]
  } else if (diff <= 100) {
    return [5, dayTickFormat]
  }

  return [7, customMonthTickFormat]
}
